export default __webpack_public_path__ + "static/media/bio-image-background.e51b2bc8.png";